import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import moment from "moment";
import { setSearchedDiscount } from "../dashboard/listing/actions";
import { getBookingPricing } from "../dashboard/bookings/actions";

function formatAsCurrency(value) {
  return isNaN(value)
    ? null
    : Number(value)
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, "$&,");
}

const mapStateToProps = (state) => ({
  searchedDiscount: state.Listing.searchedDiscount,
});

class BookingPriceBreakdownComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dateFormat: "MM/DD (ddd)",
      showDailyPricing: false,
      showTaxPricing: false,
      discountCode:
        props.booking && props.booking.discountCode
          ? props.booking.discountCode
          : "",
      searchedCode: false,
    };

    this.toggleDailyPricing = this.toggleDailyPricing.bind(this);
    this.toggleTaxPricing = this.toggleTaxPricing.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(setSearchedDiscount(null));
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.booking && this.props.booking) {
      this.setState({ discountCode: this.props.booking.discountCode });
    }
    if (
      this.state.searchedCode &&
      this.state.discountCode !== this.props.booking.discountCode
    ) {
      this.setState({
        discountCode: this.props.booking.discountCode
          ? this.props.booking.discountCode
          : this.state.discountCode,
      });
    }
  }

  searchDiscountCodes = () => {
    this.props.booking.discountCode = this.state.discountCode;
    this.props.dispatch(getBookingPricing());
    setTimeout(() => this.setState({ searchedCode: true }), 240);
  };

  toggleDailyPricing() {
    this.setState({ showDailyPricing: !this.state.showDailyPricing });
  }

  toggleTaxPricing() {
    this.setState({ showTaxPricing: !this.state.showTaxPricing });
  }

  renderBaseFee(dailyPricing, showDailyPricing) {
    if (!dailyPricing) return null;

    let total = 0;
    let individualDays = dailyPricing.map((d, i) => {
      total += d.originalPrice ? Number(d.originalPrice) : Number(d.price);
      return (
        <div key={d._id ? d._id : `d${i}`} className="row p-2 price-breakdown">
          <div className="col-7 pl-5">
            {moment(d.date).format(this.state.dateFormat)}
          </div>
          <div className="col-5 text-right currency-padded">
            <div>
              {d.originalPrice && d.originalPrice !== d.price ? (
                <div className="row">
                  <div className="col-8 discount-text-green">
                    ${formatAsCurrency(d.price)}
                  </div>
                  <div
                    className="col-4"
                    style={{ textDecoration: "line-through" }}
                  >
                    ${formatAsCurrency(d.originalPrice)}
                  </div>
                </div>
              ) : (
                <div className="row">
                  <div className="col-8 discount-text-green"></div>
                  <div className="col-4">${formatAsCurrency(d.price)}</div>
                </div>
              )}
            </div>
          </div>
        </div>
      );
    });

    // having this line resets the total to the base fee if no discount is applied
    // will probably need to adjust this when 918 gets tested
    // booking.total = total;
    return (
      <div className="col-12">
        <div className="row p-2">
          <div className="col-7 font-weight-bold">Base Rent</div>
          <div className="col-5 text-right">
            ${formatAsCurrency(total)}
            <i
              onClick={this.toggleDailyPricing}
              className="fas fa-chevron-down ml-2"
            ></i>
          </div>
        </div>
        {showDailyPricing && individualDays}
      </div>
    );
  }

  renderStreamlineBaseFee = (price) => {
    if (!price) return null;
    return (
      <div className="col-12">
        <div className="row p-2">
          <div className="col-7 font-weight-bold">Base Rent</div>
          <div className="col-5 text-right">
            ${formatAsCurrency(price)}
            <i
              className="fas fa-chevron-down ml-2"
              style={{ visibility: "hidden" }}
            ></i>
          </div>
        </div>
      </div>
    );
  };

  setDiscountCode = (e) => {
    this.setState({ discountCode: e.target.value, searchedCode: false });
    // "reset" searched discount on each user input. only set when Apply button is clicked
    this.props.dispatch(setSearchedDiscount(null));

    if (e.target.value !== this.props.booking.discountCode) {
      // clear discount if changed after Applied is set
      this.props.booking.discountCode = null;
      this.props.dispatch(getBookingPricing());
    }
  };

  renderReadOnlyDiscountCode = (booking) => {
    let discountCode = booking.discountCode ? booking.discountCode : "";
    return (
      <div className="col-12">
        <div className="row pl-2 pr-2">
          <div className="col-6 col-md-3 discount-code-input">
            <div className="col">
              <div className="row">
                <input
                  className={`form-control small`}
                  disabled={true}
                  placeholder="Discount Code"
                  style={{ paddingLeft: 10 }}
                  value={discountCode}
                />
              </div>
            </div>
          </div>
          <div className="col-6 col-md-3">
            <button className="booking-discount-btn" disabled={true}>
              Applied
            </button>
          </div>
          <div className="col-12 col-md-6 text-right currency-padded discount-alignment">
            {!booking.discountAmount
              ? null
              : `- $${booking.discountAmount.toFixed(2)}`}
          </div>
        </div>
      </div>
    );
  };

  renderSearchDiscountCode = (booking) => {
    const { searchedDiscount } = this.props;
    const { searchedCode } = this.state;
    return (
      <div className="col-12">
        <div className="row p-2">
          <div className="col-6 col-md-3 discount-code-input">
            <div className="col">
              <div className="row">
                <input
                  type="search"
                  className={`form-control small ${
                    searchedDiscount === "test"
                      ? "discount-input-disabled"
                      : null
                  }`}
                  onChange={(e) => this.setDiscountCode(e)}
                  style={{ paddingLeft: 10 }}
                  placeholder="Discount Code"
                />
              </div>
              <div className="row">
                {searchedCode &&
                (!booking.discountCode || !booking.discountAmount) ? (
                  <div className="discount-text-red">
                    Invalid discount code.
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          <div className="col-6 col-md-3">
            <button
              className="booking-discount-btn"
              onClick={() => {
                this.searchDiscountCodes();
              }}
            >
              {searchedCode &&
              booking.discountCode &&
              booking.discountAmount > 0
                ? "Applied"
                : "Apply"}
            </button>
          </div>
          <div className="col-12 col-md-6 text-right currency-padded discount-alignment">
            {!booking.discountAmount
              ? null
              : `- $${booking.discountAmount.toFixed(2)}`}
          </div>
        </div>
      </div>
    );
  };

  renderOneTimeFees(oneTimePricing) {
    if (!oneTimePricing) return null;

    let individualPricing = oneTimePricing.map((p, i) => {
      let description = p.description || p.name;
      if (description && p.count && p.count > 1)
        description += ` (x${p.count})`;
      return (
        <div className="row p-2">
          {description && (
            <div className="col-7 font-weight-bold">{description}</div>
          )}
          <div className="col-5 text-right currency-padded">
            ${formatAsCurrency(p.price || p.value)}
          </div>
        </div>
      );
    });
    return <div className="col-12">{individualPricing}</div>;
  }

  renderApproval(total) {
    if (!total) return <div />;
    return (
      <div className="col-12 smaller mb-2">
        <span className="semi-bold">Booking Approval:</span> If your request is
        accepted, your booking will be completed and you will automatically be
        charged <strong>${formatAsCurrency(total)}</strong>.
      </div>
    );
  }

  renderDeposit(depositPricing) {
    if (!depositPricing) return null;
    return (
      <div className="col-12 smaller">
        <span className="semi-bold">Security Deposit:</span> A security deposit
        of
        <strong> ${formatAsCurrency(depositPricing.price)}</strong> will be held
        on your active credit card 48 hours prior to check-in.
      </div>
    );
  }

  renderTaxFees(taxPricing, showTaxPricing) {
    if (!taxPricing) return null;

    let total = 0;
    let individualTaxes = taxPricing.map((t, i) => {
      const description = t.name || t.description;
      const price = t.price || t.value;
      total += Number(price);
      let percent = t.amount ? `(${(t.amount * 100).toFixed(0)}%)` : "";
      return (
        <div key={t._id ? t._id : `t${i}`} className="row p-2 price-breakdown">
          <div className="col-7 pl-5">
            {description} {percent}
          </div>
          <div className="col-5 text-right currency-padded">
            ${formatAsCurrency(price)}
          </div>
        </div>
      );
    });

    if (!individualTaxes.length) return null;

    return (
      <div className="col-12">
        <div className="row p-2">
          <div className="col-7 font-weight-bold">Taxes</div>
          <div className="col-5 text-right">
            ${formatAsCurrency(total)}
            <i
              onClick={this.toggleTaxPricing}
              className="fas fa-chevron-down ml-2"
            ></i>
          </div>
        </div>
        {showTaxPricing && individualTaxes}
      </div>
    );
  }

  renderOwnerServiceFee(servicePricing) {
    if (!servicePricing) return <div />;
    return (
      <div className="col-12">
        <div className="row p-2">
          <div className="col-7 font-weight-bold">{`Host Service Fee (${(
            servicePricing.amount * 100
          ).toFixed(0)}%)`}</div>
          <div className="col-5 text-right currency-padded">
            -${formatAsCurrency(servicePricing.price)}
          </div>
        </div>
      </div>
    );
  }

  renderServiceFee(servicePricing) {
    if (!servicePricing) return <div />;
    return (
      <div className="col-12">
        <div className="row p-2">
          <div className="col-7 font-weight-bold">CollegeWeekends Service Fee</div>
          <div className="col-5 text-right currency-padded">
            ${formatAsCurrency(servicePricing.price)}
          </div>
        </div>
      </div>
    );
  }

  render() {
    let { booking, isOwner, type, isStreamlineListing } = this.props;
    let { showDailyPricing, showTaxPricing } = this.state;
    if (!booking) return <div>Loading...</div>;
    let extraHeaderText = type === "owner" ? "Owner " : "Renter ";

    const discountComponent = booking._id
      ? this.renderReadOnlyDiscountCode(booking)
      : this.renderSearchDiscountCode(booking);

    return (
      <div>
        <div className="row">
          <div className="col-12">
            <h3>{type && extraHeaderText}Price Breakdown</h3>
          </div>
        </div>
        <div className="row">
          {isStreamlineListing
            ? this.renderStreamlineBaseFee(booking.price)
            : this.renderBaseFee(booking.dailyPricing, showDailyPricing)}
          {isStreamlineListing ? null : discountComponent}
          {this.renderOneTimeFees(booking.oneTimePricing)}
          {!!booking.subTotal && (
            <div className="col-12">
              <div className="row p-2">
                <div className="col-7 font-weight-bold">Subtotal</div>
                <div className="col-5 text-right currency-padded">
                  ${formatAsCurrency(booking.subTotal)}
                </div>
              </div>
            </div>
          )}
          {this.renderTaxFees(booking.taxPricing, showTaxPricing)}
          {isOwner || type === "owner"
            ? this.renderOwnerServiceFee(booking.ownerServicePricing)
            : this.renderServiceFee(booking.servicePricing)}
        </div>
        <hr />
        <div className="row p-2">
          <div className="col-7 font-weight-bolder">Total</div>
          <div className="col-5 text-right currency-padded">
            $
            {formatAsCurrency(
              isOwner || type === "owner" ? booking.ownerTotal : booking.total
            )}
          </div>
        </div>
        <div className="row p-2 mb-3">
          {!booking._id &&
            !(isOwner || type === "owner") &&
            this.renderApproval(booking.total)}
          {!!booking.depositPricing &&
            !!booking.depositPricing.price &&
            !(isOwner || type === "owner") &&
            this.renderDeposit(booking.depositPricing)}
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect(mapStateToProps)(BookingPriceBreakdownComponent)
);
